import { forwardRef, Ref, type SVGProps } from 'react';

const SvgPaymentPaypal = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 24"
    ref={ref}
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#cdd7d6"
      rx={2.5}
    />
    <path
      fill="#253B80"
      fillRule="evenodd"
      d="M9.9 15.238H8.344a.216.216 0 0 0-.213.182l-.63 3.99a.13.13 0 0 0 .129.15h.743a.216.216 0 0 0 .213-.184l.17-1.076a.216.216 0 0 1 .213-.182h.493c1.024 0 1.616-.496 1.77-1.479q.104-.647-.198-1.004c-.221-.26-.613-.397-1.134-.397m.18 1.457c-.086.558-.512.558-.924.558H8.92l.164-1.043a.13.13 0 0 1 .129-.109h.107c.281 0 .546 0 .683.16.082.096.107.238.075.434m4.47-.018h-.745a.13.13 0 0 0-.128.11l-.033.208-.052-.076c-.161-.234-.52-.312-.88-.312-.823 0-1.526.623-1.663 1.498-.071.436.03.853.277 1.144.227.268.552.38.939.38.663 0 1.03-.427 1.03-.427l-.032.207a.13.13 0 0 0 .127.15h.671a.216.216 0 0 0 .214-.183l.403-2.55a.13.13 0 0 0-.128-.15m-1.038 1.45a.83.83 0 0 1-.84.711c-.217 0-.39-.07-.5-.2-.111-.131-.153-.317-.118-.524a.834.834 0 0 1 .835-.717c.211 0 .383.07.497.203.113.134.158.32.126.527m4.257-1.45h.749a.13.13 0 0 1 .106.203l-2.49 3.594a.22.22 0 0 1-.177.093h-.748a.13.13 0 0 1-.106-.205l.775-1.094-.824-2.42a.13.13 0 0 1 .123-.171h.735c.096 0 .18.063.208.154l.437 1.462 1.033-1.521a.22.22 0 0 1 .179-.095"
      clipRule="evenodd"
    />
    <path
      fill="#179BD7"
      fillRule="evenodd"
      d="m25.885 19.41.639-4.063a.13.13 0 0 1 .127-.11h.72c.079 0 .14.072.127.15l-.63 3.99a.216.216 0 0 1-.213.182h-.642a.13.13 0 0 1-.128-.15m-4.89-4.172H19.44a.216.216 0 0 0-.213.182l-.63 3.99a.13.13 0 0 0 .128.149h.799a.15.15 0 0 0 .149-.128l.178-1.13a.216.216 0 0 1 .214-.183h.492c1.025 0 1.616-.496 1.77-1.479.07-.43.003-.768-.198-1.004-.22-.26-.613-.397-1.133-.397m.18 1.457c-.085.558-.511.558-.924.558h-.234l.165-1.043a.13.13 0 0 1 .127-.11h.108c.28 0 .546 0 .683.161.082.096.106.238.075.434m4.47-.018h-.744a.13.13 0 0 0-.128.11l-.033.207-.052-.075c-.161-.234-.52-.312-.88-.312-.823 0-1.526.623-1.663 1.498-.07.436.03.853.277 1.144.228.268.552.379.939.379.663 0 1.03-.427 1.03-.427l-.032.208a.13.13 0 0 0 .128.15h.67a.216.216 0 0 0 .214-.183l.403-2.55a.13.13 0 0 0-.129-.15m-1.038 1.45a.83.83 0 0 1-.84.71c-.216 0-.39-.069-.5-.2-.11-.13-.152-.316-.117-.523a.834.834 0 0 1 .834-.717c.212 0 .384.07.497.203a.64.64 0 0 1 .126.527"
      clipRule="evenodd"
    />
    <path
      fill="#253B80"
      d="m15.656 13.81.19-1.214-.425-.01h-2.034L14.8 3.622a.116.116 0 0 1 .115-.098h3.43c1.139 0 1.925.237 2.335.705.192.22.315.449.374.7.062.266.064.582.003.968l-.005.028v.247l.193.11q.241.127.39.296.247.283.315.709c.046.29.031.636-.045 1.028-.088.45-.23.843-.421 1.164q-.265.445-.668.731-.383.272-.898.406c-.332.086-.71.13-1.124.13h-.267a.807.807 0 0 0-.794.678l-.02.109-.338 2.14-.015.08q-.005.034-.021.045a.06.06 0 0 1-.035.013z"
    />
    <path
      fill="#179BD7"
      d="M21.427 5.954q-.015.098-.035.2c-.453 2.323-2 3.126-3.977 3.126H16.41a.49.49 0 0 0-.483.413l-.515 3.268-.146.926a.258.258 0 0 0 .254.298h1.785a.43.43 0 0 0 .424-.362l.018-.09.336-2.133.021-.117a.43.43 0 0 1 .424-.363h.267c1.73 0 3.083-.702 3.48-2.734.164-.849.079-1.557-.359-2.056a1.7 1.7 0 0 0-.488-.376"
    />
    <path
      fill="#222D65"
      d="M20.954 5.765a4 4 0 0 0-.44-.098 5.6 5.6 0 0 0-.888-.064h-2.688a.43.43 0 0 0-.424.362l-.572 3.623-.016.105a.49.49 0 0 1 .483-.413h1.006c1.977 0 3.524-.803 3.977-3.125l.035-.201a2.4 2.4 0 0 0-.474-.189"
    />
    <path
      fill="#253B80"
      d="M16.516 5.965a.43.43 0 0 1 .423-.362h2.689q.479-.001.887.065a4 4 0 0 1 .44.097l.102.032q.2.066.371.157c.135-.859 0-1.443-.465-1.972-.511-.583-1.435-.832-2.616-.832h-3.43a.49.49 0 0 0-.485.414l-1.428 9.056c-.029.18.11.341.29.341h2.118l.532-3.373z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaymentPaypal);
export default ForwardRef;
